import service from '@/base/service'
// const baseURL = process.env.VUE_APP_LOCALHOST
const baseURL = process.env.VUE_APP_BASE_API_AI

const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

export const mergeContacts = (data) => {
  const { contactInfoList } = data
  if (!contactInfoList) return data
  const obj = {}
  contactInfoList.forEach(item => {
    const { companyName, contacts } = item
    if (obj[companyName]) obj[companyName].contacts.push(...contacts)
    else {
      obj[companyName] = {
        ...item,
        contacts: [...contacts]
      }
    }
  })
  return {
    ...data,
    contactInfoList: Object.values(obj)
  }
}

//  根据企业名称获取企业基本信息(包括联系方式)
export function basicInfo(data) {
  return request({
    url: 'clue/basicInfo',
    method: 'get',
    params: data
  })
}

//  根据公司id获取关系图谱
export function chart(data) {
  return request({
    url: 'relation/chart',
    method: 'get',
    params: data
  })
}

//  查询我的关注
// export function getStarCompany (data) {
//   return request({
//     url: 'clue/getStarCompany',
//     method: 'get',
//     params: data
//   })
// }
//  查询我的关注 - HID
export function getStarCompany(data) {
  return request({
    url: 'vv5/clue/getStarCompany',
    method: 'get',
    params: data
  })
}

//  获取商业线索 弃用
export function search(data) {
  return request({
    url: 'clue/search',
    method: 'post',
    data
  })
}

//  获取商业线索 筛选用
// export function searchByCondition (data) {
//   return request({
//     url: 'clue/searchByCondition',
//     method: 'post',
//     data
//   })
// }
//  获取商业线索 筛选用 - HID
export function searchByCondition(data, cancelToken) {
  return request({
    url: 'vv5/clue/searchByCondition',
    method: 'post',
    data,
    cancelToken
  })
}



//  关注
// export function star (data) {
//   return request({
//     url: 'clue/star',
//     method: 'post',
//     data
//   })
// }
// 关注 - HID
export function star(data) {
  return request({
    url: 'vv5/clue/star',
    method: 'post',
    data
  })
}

//  推荐列表
export function recommendedList(data) {
  return request({
    url: 'clue/recommendedList',
    method: 'get',
    params: data
  })
}

//  资质证书
export function certificate(data) {
  return request({
    url: 'operation/certificate',
    method: 'get',
    params: data
  })
}

//  招聘信息
export function employments(data) {
  return request({
    url: 'operation/employments',
    method: 'get',
    params: data
  })
}

//  行政许可
export function getLicense(data) {
  return request({
    url: 'operation/getLicense',
    method: 'get',
    params: data
  })
}

//  获取变更信息
export function changeInfo(data) {
  return request({
    url: 'background/changeInfo',
    method: 'get',
    params: data
  })
}

//  获取股东信息
export function holder(data) {
  return request({
    url: 'background/holder',
    method: 'get',
    params: data
  })
}

//  企业主要人员
export function keyMan(data) {
  return request({
    url: 'background/keyMan',
    method: 'get',
    params: data
  })
}

//  专利信息
export function parents(data) {
  return request({
    url: 'ipr/parents',
    method: 'get',
    params: data
  })
}

//  商标信息
export function tm(data) {
  return request({
    url: 'ipr/tm',
    method: 'get',
    params: data
  })
}

//  根据公司名查询联系方式
export function getContactInfo(data) {
  return request({
    url: 'clue/getContactInfo',
    method: 'get',
    params: data
  })
}

// 解锁列表
export function unlockList(data) {
  return request({
    url: '/clue/newUnlockList',
    method: 'post',
    data
  })
}

// 解锁列表 v4.0
// export function unlockListV3 (data) {
//   return request({
//     url: '/clue/unlockListV3',
//     method: 'post',
//     data
//   })
// }
// 解锁列表 v4.0 - HID
// export function unlockListV3 (data) {
//   return request({
//     url: 'vv5/clue/unlockList',
//     method: 'post',
//     data
//   })
// }

// 解锁接口变更
export function unlockListV3(data) {
  return request({
    url: 'vv6/clue/unlockList',
    method: 'post',
    data
  })
}


export function exportUnlockListExcel(data) {
  return request({
    url: '/vv5/clue/exportUnlock',
    method: 'post',
    responseType: 'blob',
    timeout: 1800000,
    data
  })
}

// 转线索 v4.0
// export function contactSubmitV2 (data) {
//   return request({
//     url: '/contact/contactSubmitV2',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }
// 转线索 v4.0 - HID
export function contactSubmitV2(data) {
  return request({
    url: '/vv5/contact/contactSubmit',
    method: 'post',
    data: mergeContacts(data)
  })
}

// 回收站恢复操作 v4.0
// export function contactRevocation (data) {
//   return request({
//     url: '/contact/contactRevocation',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }
// 回收站恢复操作 v4.0 - HID
export function contactRevocation(data) {
  return request({
    url: '/vv5/contact/contactRevocation',
    method: 'post',
    data: mergeContacts(data)
  })
}

// 删除回收站，批量删除回收站 v4.0
// export function removeContactToTrash (data) {
//   return request({
//     url: '/contact/removeContactToTrash',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }
// 删除回收站，批量删除回收站 v4.0 - HID
export function removeContactToTrash(data) {
  return request({
    url: '/vv5/contact/removeContactToTrash',
    method: 'post',
    data: mergeContacts(data)
  })
}

// // 删除回收站公司维度 v4.0
// export function removeCompanyToTrash (data) {
//   return request({
//     url: '/contact/removeCompanyToTrash',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }

// 删除回收站公司维度 v4.0 - HID
export function removeCompanyToTrash(data) {
  return request({
    url: '/vv5/contact/removeCompanyToTrash',
    method: 'post',
    data: mergeContacts(data)
  })
}

// 回收站 删除 v4.0
// export function contactReset (data) {
//   return request({
//     url: '/contact/contactReset',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }
// 回收站 删除 v4.0 - HID
export function contactReset(data) {
  return request({
    url: '/vv5/contact/contactReset',
    method: 'post',
    data: mergeContacts(data)
  })
}

// 等会儿再打/无意向 v4.0
// export function contactOperate (data) {
//   return request({
//     url: '/contact/contactOperate',
//     method: 'post',
//     data: mergeContacts(data)
//   })
// }
// 等会儿再打/无意向 v4.0 - HID
export function contactOperate(data) {
  return request({
    url: '/vv5/contact/contactOperate',
    method: 'post',
    data: mergeContacts(data)
  })
}

// 等会再打总数 v4.0
export function contactCallLaterCount(data) {
  return request({
    url: '/clue/contactCallLaterCount',
    method: 'post',
    data
  })
}

// 智能询盘-解锁列表 v4.0
export function queryUnlockList(data) {
  return request({
    url: '/shortVideo/queryUnlockList',
    method: 'post',
    data
  })
}

// 智能询盘-修改解锁列表状态
export function updateUnlockStatus(data) {
  return request({
    url: '/shortVideo/updateUnlockStatus',
    method: 'post',
    data
  })
}

// 智能询盘-获取等会再打数量
export function getIsWaitNum(data) {
  return request({
    url: '/shortVideo/getIsWaitNum',
    method: 'post',
    data
  })
}

// 智能推荐-数量
export function getTransactionCompanyNum(data) {
  return request({
    url: '/transaction/getTransactionCompanyNum',
    method: 'get'
  })
}

// 企业上报更新-上报更新企业 - 查不到对应的企业
export function companySubmit(data) {
  return request({
    url: '/companysubmit/submit',
    method: 'POST',
    data
  })
}
// 企业上报更新-上报更新企业 - HID
export function companySubmitH(data) {
  return request({
    url: '/vv5/companysubmit/submit',
    method: 'POST',
    data
  })
}
// 企业上报更新-轮询获取上报企业更新结果
export function getCompanySubmitResult(data) {
  return request({
    url: '/companysubmit/result',
    method: 'get',
    data
  })
}
// 企业上报更新-设置上报企业已经停止前端
export function updateCompanySubmitStatus(data) {
  return request({
    url: '/companysubmit/update',
    method: 'POST',
    data
  })
}
// 企业上报更新-获取更新信息
// export function getCompanyInfo (data) {
//   return request({
//     url: '/companyDetail/companyInfo',
//     method: 'POST',
//     data: data
//   })
// }
// 企业上报更新-获取更新信息
export function getCompanyInfo(data) {
  return request({
    url: 'vv5/companyDetail/companyInfo',
    method: 'POST',
    data: data
  })
}

//  添加种子企业
export function transactionAdd(data) {
  return request({
    url: '/transaction/add',
    method: 'post',
    data
  })
}
// 删除中资企业
export function transactionDel(data) {
  return request({
    url: '/transaction/delete',
    method: 'get',
    params: data
  })
}

// 查询解锁列表筛选条件 (是否代理记账 是否疑似KP)
export function getUnlock(data) {
  return request({
    url: '/dict/unlock',
    method: 'get',
    data
  })
}

// 企业查询 批量解锁前500
export function searchByConditionUnlock(data) {
  return request({
    url: 'vv6/clue/searchByConditionUnlock',
    method: 'post',
    data
  })
}

// 解锁列表组件 复制
export function contactCopy(data) {
  return request({
    url: '/contact/copy',
    method: 'post',
    data
  })
}
// 新增修改标签 contact/label
export function contactLabel(data) {
  return request({
    url: '/contact/label',
    method: 'post',
    data
  })
}

// 新增修改备注 contact/remark
export function contactRemark(data) {
  return request({
    url: 'contact/remark',
    method: 'post',
    data
  })
}
